import image from "../images/profile_image.png"

export const StringConstant = {
  SIGN_UP_BIRTHDAY_ERROR: 'Please input the date in the format mm.dd.yyyy',
  SIGN_UP_ELIGIBITY_ERROR: 'Looks like you are not eligible for EyeBall',
  SIGN_UP_NEW_TO_INVESTING: 'Are you new to investing?',
  SIGN_UP_INTEREST_SUBHEADER: 'Follow companies, people, and investing themes, then we’ll build your personalized feed',
  SIGN_UP_PASSWORD_ERROR: 'Check the correctness of your password',
  SIGN_UP_YOUR_NAME: 'What’s your name?',
  ENTER_FIRST_NAME: 'Enter first name',
  ENTER_LAST_NAME: 'Enter last name',
  SIGN_UP_PROFILE_MESSAGE: ' This will be what shows on your profile',
  INTRODUCTION: 'Create a profile, follow other accounts, make your own videos, and more',
  SIGN_UP_GETTING_STARTED: 'I’m just getting started',
  SIGN_UP_INVESTING_FOR_WHILE: ' I’ve been investing for a while',
  SIGN_UP_ALREADY_REGISTERED: 'Are you already registered',
  SIGN_IN: 'Sign in',
  NEW_PASSWORD_SUCCESS: 'You have successfully updated your password',
  NEW_PASSWORD_ERROR: 'Check the correctness of your password',
  NEW_PASSWORD_MISMATCH: 'Passwords should match',
  LOG_IN_ERROR_MEESAGE: 'Sorry, it seems like there is an issue logging you in. Please contact us if the issue persists.',
  SIGN_UP_ERROR_MEESAGE: 'Sorry, it seems like there is an issue singing you up. Please contact us if the issue persists.',
  RESET_PASSWORD_ERROR_MEESAGE: 'Sorry, it seems like there is an issue send you a reset link. Please contact us if the issue persists.',
  BECOME_EXPERT_INITIAL_ERROR: 'Error occured while submitting the Become a creator request. Please try again.',
  BECOME_EXPERT_SUCCESS: 'Thank you for your interest in becoming an expert. We will reach out to you shortly.',
  EXPERT_SOCIAL_LINK_ERROR: 'Error occured while updating Social Media links. Please contact us if the issue persists.',
  EXPERT_PERSONAL_DATA_ERROR: 'Error while Updating Personal data.  Please contact us if the issue persists.',
  ECONOMY: 'Economy',
}


export const DEFAULT_AVATAR = image
